import { type Text1Card, Text1CardSchema } from "@stackje/common/config";
import { ValidationError, getStringFromFormData, getOptionalStringFromFormData } from "./validation";

export function parseTextCard(formData: FormData): Text1Card {
  const cardData = {
    type: "text1" as const,
    colors: JSON.parse(formData.get("colors") as string),
    title: getOptionalStringFromFormData(formData, "title"),
    subtitle: getStringFromFormData(formData, "subtitle"),
  };

  try {
    return Text1CardSchema.parse(cardData);
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}
